import * as React from 'react';

import {SettingsSidebar} from '../settings-sidebar';

import {ActivityTypeDefaults} from './activity-type-defaults';
import {ActivityTypesTable} from './activity-types-table';

import styles from './activity-types.module.css';

export function ActivityTypes() {
    return (
        <div className={styles.container}>
            <div className='flex flex-dir-col gap-16'>
                <ActivityTypeDefaults />
                <ActivityTypesTable />
            </div>
            <SettingsSidebar glossaryKey='/setup/activity-type' />
        </div>
    );
}
